module.exports = __webpack_public_path__ + "static/media/shield-2.6b75b65d.glb";